import { useEffect, useState } from "react";

interface Comment {
  id: string;
  name: string;
  content: string;
  date: string;
}

interface CommentSectionProps {
  articleId: string;
}

function seedComments(): Comment[] {
  return [
    {
      id: "seed-1",
      name: "夜里看番的人",
      content: "写得太好了，看完又想去把这部作品重刷一遍。",
      date: "2026-10-09 22:14"
    },
    {
      id: "seed-2",
      name: "泡泡茶壶",
      content: "作者的分析角度很独特，特别是关于角色成长的那一段，狠狠共鸣了。",
      date: "2026-10-08 18:02"
    }
  ];
}

export default function CommentSection({ articleId }: CommentSectionProps) {
  const storageKey = `loli-comments-${articleId}`;
  const [comments, setComments] = useState<Comment[]>([]);
  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [tip, setTip] = useState("");

  useEffect(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      setComments(raw ? (JSON.parse(raw) as Comment[]) : seedComments());
    } catch {
      setComments(seedComments());
    }
  }, [storageKey]);

  const persist = (list: Comment[]) => {
    setComments(list);
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch {
      /* ignore */
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) {
      setTip("请先输入评论内容");
      return;
    }
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
    const newComment: Comment = {
      id: `c-${Date.now()}`,
      name: name.trim() || "热心同好",
      content: content.trim(),
      date: dateStr
    };
    persist([newComment, ...comments]);
    setContent("");
    setTip("评论发布成功（演示环境，仅保存在本机）");
    setTimeout(() => setTip(""), 3000);
  };

  return (
    <section className="mt-12">
      <h2 className="mb-4 flex items-center gap-2 text-xl text-foreground-950">
        <i className="ri-chat-3-line text-primary-500"></i>
        评论区
        <span className="text-sm font-normal text-foreground-500">({comments.length})</span>
      </h2>

      <form
        onSubmit={handleSubmit}
        className="rounded-lg border border-background-200 bg-background-50 p-4"
      >
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={20}
          placeholder="你的昵称（可选）"
          className="w-full rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-300 focus:outline-none sm:w-64"
        />
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value.slice(0, 500))}
          rows={3}
          placeholder="友善发言，分享你的看法～"
          className="mt-3 w-full resize-none rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-500 focus:border-primary-300 focus:outline-none"
        />
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-foreground-500">{content.length} / 500</span>
          <button
            type="submit"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
          >
            <i className="ri-send-plane-line"></i>
            发表评论
          </button>
        </div>
        {tip && <p className="mt-2 text-xs text-primary-600">{tip}</p>}
      </form>

      <div className="mt-6 space-y-4">
        {comments.length === 0 ? (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-100/60 py-10 text-center text-sm text-foreground-500">
            还没有评论，快来抢沙发吧～
          </p>
        ) : (
          comments.map((c) => (
            <div key={c.id} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-user-smile-line text-lg"></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-sm font-medium text-foreground-900">{c.name}</span>
                  <span className="text-xs text-foreground-500">{c.date}</span>
                </div>
                <p className="mt-1 text-sm leading-relaxed text-foreground-700">{c.content}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}